module.exports = __webpack_public_path__ + "static/media/18 - Carlton williams - Prison Song.eb580802.mp3";